export enum SupplierType {
  External = 1,
  Internal = 2
}
